import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';
import {
  SummaryCustomerAdvancePaymentListModel,
  SummaryCustomerAdvancePaymentModel
} from '../../models/summary-customer-advance-payment.model';
import { CustomerAdvancePaymentService } from '../../services/customer-advance-payment.service';
import {
  CustomerAdvancePaymentActionTypes,
  LoadCustomerAdvancePayments,
  LoadCustomerAdvancePaymentsFailure,
  LoadCustomerAdvancePaymentsSuccess
} from '../actions/customer-advance-payment.actions';

@Injectable()
export class CustomerAdvancePaymentEffects {
  constructor(
    private actions$: Actions,
    private service: CustomerAdvancePaymentService
  ) { }

  
  load$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(CustomerAdvancePaymentActionTypes.Load),
    switchMap((action: LoadCustomerAdvancePayments) =>
      this.service.getSummaryList(action.payload.filter).pipe(
        map((res: PaginableResponseModel<SummaryCustomerAdvancePaymentModel> & { summary: SummaryCustomerAdvancePaymentListModel }) => {
          if (!res || !res.isSuccess) {
            return new LoadCustomerAdvancePaymentsFailure({ error: 'No se pudo cargar la lista de anticipos' });
          }
          return new LoadCustomerAdvancePaymentsSuccess({
            items: res.values,
            total: res.total,
            summary: res.summary
          });
        }),
        catchError(error => of(new LoadCustomerAdvancePaymentsFailure({ error })))
      )
    )
  ));
}
